import { dispatcher, ingenuity } from "@quest/base-core";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";
import { SlotEventConstantsBehavior, WinPresentationPanelBehavior } from "@quest/murka-games-behavior-panther";


import { GameParserModel } from "../Platform/GameParserModel";

export class WinPresentationPanelGame extends WinPresentationPanelBehavior {
  /**overrided to clear winpresentation reels on win presentation suspend
   */
  protected stopAllWinLineSymbol(): void {
    this.clearSymReels();
    super.stopAllWinLineSymbol();
  }

  // Overrided to pass winning symbols data according to symbols lines win
  protected animateAllWinLineSymbol(): void {
    this.model.playLineWinAnim = true;
    const winLineData = (ingenuity.parserModel as platformModel).getWinLinesData()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
        (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ].positions;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA_ON_SYMBOL, winLineData);
    if (winLineData.length < 1) {
      return;
    }
    winLineData.sort(this.sortFirstColumn);
    winLineData.sort(this.sortSecondColumn);
    for (const element of winLineData) {
      this.animateLineSymbol(element);
    }
  }
}
